var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({directives:[{name:"track-click",rawName:"v-track-click"}],staticClass:"t-btn",class:[_vm.colorVariant],attrs:{"type":"button"}},'button',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[_c('span',{staticClass:"t-btn__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }